import { observer } from 'mobx-react-lite'
import { Button } from 'shared/ui'
import { useEnrollmentActionsContext } from './EnrollmentActionsProvider'

export const EnrollmentActions = observer(() => {
  const { onCancel, onConfirm, selectDisabled, selectTitle, loading, showDisabledTooltip } =
    useEnrollmentActionsContext()

  return (
    <>
      <Button text={'Cancel'} contained={'secondary'} size={'medium'} onClick={onCancel} />
      <Button
        disabled={selectDisabled}
        loading={loading}
        text={selectTitle}
        size={'medium'}
        onClick={onConfirm}
        tooltipProps={
          selectDisabled && showDisabledTooltip
            ? {
                type: 'description',
                label: '0 contacts match this filter',
                desc: 'Adjust it to continue',
                placement: 'top',
              }
            : undefined
        }
      />
    </>
  )
})
